import { Component, OnDestroy, OnInit, signal, WritableSignal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, debounceTime } from 'rxjs';
import { LocaleService } from 'src/app/core/locale/locale.service';
import { selectCatalog } from 'src/app/root-store/catalog-store/selectors';
import { CatalogState } from 'src/app/root-store/catalog-store/state';
import { RootState } from 'src/app/root-store/root-state.model';
import { selectQueryParams, selectRouteParam, selectUrl } from 'src/app/root-store/router/selectors';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-language-switch',
  standalone: true,
  imports: [RouterModule, MatButtonModule, MatMenuModule, MatIconModule],
  templateUrl: './language-switch.component.html',
  styleUrl: './language-switch.component.scss'
})
export class LanguageSwitchComponent implements OnInit, OnDestroy {
  langRelativeUrl: WritableSignal<string | undefined> = signal(undefined)
  langSwitchQueryParams: WritableSignal<{ [key: string]: string }> = signal({})
  catalog!: CatalogState

  private subs = new SubSink()

  constructor(
    private store: Store<RootState>,
    public localeService: LocaleService,
  ) { }

  ngOnInit(): void {
    this.catalog = this.store.selectSignal(selectCatalog)()

    // update langRelativeUrl when route changes
    this.subs.sink = combineLatest([
      this.store.select(selectUrl),
      this.store.select(selectQueryParams)
    ])
      .pipe(debounceTime(0))
      .subscribe(([url, queryParams]) => {
        const urlMatch = url.match(/\/[^/]+\/\w{2}\/?([^?]*)/)
        const langParam = this.store.selectSignal(selectRouteParam('lang'))()
        const currentCulture = this.localeService.supported.find(s => s.language === langParam)
        this.langRelativeUrl.set(urlMatch && currentCulture ? urlMatch[1] : undefined)
        this.langSwitchQueryParams.set(queryParams)
      })
  }

  onLanguageClick(event: MouseEvent, culture: string) {
    // when a link is clicked which has no href, set language
    if (!(event.target as HTMLAnchorElement).href)
      this.localeService.setCultureAsync(culture)
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe()
  }
}
